import React, { useContext, useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CRow,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CTableRow,
  CTableHeaderCell,
  CTable,
  CTableBody,
  CTableDataCell,
  CBadge,
  CCardBody,
  CTableHead,
  CImage,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import DownloadExcel from "src/reusables/DownloadExcel";
import { DataGrid } from "@mui/x-data-grid";
import formatter from "src/reusables/formatter";
import { getAll, getDetails } from "src/services/Visitations";
import { Toaster } from "src/components/Toaster";
import { format, isWeekend } from "date-fns";
import ls from "local-storage";
import Authentication, { AUTH_KEY } from "src/utils/auth/Authentication";
import { AuthContext } from "src/App";
import Moment from "moment";
import { DateRangePicker } from "react-date-range";
import { useLocation, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { usePaginationState } from "src/reusables/usePaginationState";
function Visitations() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0);
  const [userID, setUserID] = useState(0);
  const [detailModal, setDetailModal] = useState(false);
  const [selectedWP, setSelectedWP] = useState({});
  const [details, setDetails] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [position, setPosition] = useState([]);
  const location = useLocation();
  const useWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    const comparison = width / height;
    const [windowDimensions, setWindowDimensions] = useState({
      width,
      height,
      comparison,
    });
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    useEffect(() => {
      function handleResize() {
        const { innerWidth: width, innerHeight: height } = window;
        const comparison = width / height;
        setWindowDimensions({ width, height, comparison });
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width, comparison } = useWindowDimensions();
  const [paginationModel, setPaginationModel] = usePaginationState();

  const [drModal, setDrModal] = useState(false);
  const endDay = Moment(new Date()).format("YYYY-MM-DD");
  const max = new Date(endDay);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf("month")}`),
      endDate: new Date(),
    },
  ]);

  async function fetchDetails(id) {
    const res = await getDetails(id);
    console.log(res);
    setDetails(res.details);
    setStocks(res.stock);
    setPosition([parseFloat(res.details.latitude), parseFloat(res.details.longitude)]);
  }
  const formatTime = (time) => {
    if (!time) return <CBadge color="secondary">Belum</CBadge>;
    return time;
  };

  // Calculate visit status
  const getVisitStatus = (details) => {
    if (!details.visited_at) return <CBadge color="danger">Not Visited</CBadge>;
    if (details.visited_at && !details.check_in) return <CBadge color="danger">Not Visited</CBadge>;

    if (details.visited_at && !details.check_out) return <CBadge color="warning">Checked In</CBadge>;
    return <CBadge color="success">Completed</CBadge>;
  };
  async function fetchMainData({ dateFrom, dateTo, userID }) {
    const res = await getAll({
      dateFrom: dateFrom,
      dateTo: dateTo,
      userID: userID,
    });
    const rows =
      res.visitations &&
      res.visitations.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.userName,
          storeName: item.storeName,
          checkIn: item.check_in,
          checkOut: item.check_out ?? "Belum",
          visibility: item.visibility,
          duration: item.duration,
          date: item.date ? formatter("dateOnly", item.created_at) : "",
          rawDate: item.created_at,
        };
      });
    //   {
    //     "id": 1,
    //     "user_id": 1,
    //     "wd_id": 15,
    //     "store_id": 2,
    //     "work_plan_id": 0,
    //     "check_in": "13:54:32",
    //     "check_out": null,
    //     "created_at": "2025-05-07T06:54:32.000Z",
    //     "visibility": "Medium",
    //     "storeName": "Vaporline Dago",
    //     "userName": "Harry",
    //     "date": "2025-05-16"
    // },
    setDataRows(rows);

    const columns = [
      { field: "no", headerName: "No", width: "50" },
      { field: "date", headerName: "Tanggal", flex: 1 },
      { field: "name", headerName: "Nama", flex: 1 },
      { field: "storeName", headerName: "Toko", flex: 1 },
      { field: "checkIn", headerName: "Check In", flex: 1 },
      { field: "checkOut", headerName: "Check Out", flex: 1 },
      { field: "duration", headerName: "Durasi (Menit)", flex: 1 },
    ];

    setDataColumns(columns);
  }
  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: "5px",
            width: "5px",
            borderRadius: "100%",
            background: "orange",
            position: "absolute",
            top: 2,
            right: 2,
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: "600",
          }}
        >
          {format(day, "d")}
        </span>
      </div>
    );
  }
  useEffect(() => {
    const newStartDay = formatter("SQLDate", dateRange[0].startDate);
    const newEndDay = formatter("SQLDate", dateRange[0].endDate);
    if ((refetch && renderCounter > 0) || renderCounter === 0) {
      fetchMainData({
        dateFrom: newStartDay,
        dateTo: newEndDay,
        userID: userID,
      });
      setRefetch(false);
    }
    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal, userID]);
  function handleRowClick(params) {
    navigate(`/visitations/details/${params.row.id}`, {
      state: {
        fromPage: paginationModel.page,
        fromPageSize: paginationModel.pageSize,
      },
    });
  }

  // Remove all the modal-related JSX (CModal components) from your return statement
  return (
    <div style={{ color: "black" }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? "red"} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Kunjungan </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: "right" }}>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel
                rows={dataRows}
                columns={dataColumns}
                excelName="Daftar Visitations"
                config={{ width: "20" }}
              />
            </CCol>
          </CRow>
          <CRow style={{ overflow: "scroll" }}>
            <CCol>
              <CButton
                className="ml-3 mb-3 btn btn-dark"
                style={{ backgroundColor: "#306fba", border: "none" }}
                hover="true"
                onClick={() => {
                  setDrModal(!drModal);
                }}
              >
                <div>
                  {Moment(dateRange[0].startDate).format("ll")}
                  {" - "}
                  {Moment(dateRange[0].endDate).format("ll")}
                </div>
              </CButton>
            </CCol>
          </CRow>
          <CModal visible={drModal}>
            <CModalHeader>
              {" "}
              <CModalTitle>Date Range</CModalTitle>
            </CModalHeader>
            <CModalBody>
              {" "}
              <CCol xs="12" lg="10">
                <DateRangePicker
                  onChange={(item) => {
                    setDateRange([item.range1]);
                    ls.set("dateRange", item.range1);
                  }}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={1}
                  maxDate={max}
                  ranges={dateRange}
                  direction="vertical"
                  weekStartsOn={1}
                  calendarFocus="backwards"
                  preventSnapRefocus={true}
                  rangeColors={["#4E5B97"]}
                  dayContentRenderer={customDayContent}
                />
              </CCol>
            </CModalBody>
            <CModalFooter
              style={{
                width: comparison < 1 ? `${(85 * 1) / comparison}vw` : "",
              }}
            >
              <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => setDrModal(!drModal)}>
                Close
              </CButton>
              <CButton
                style={{ backgroundColor: "#4E5B97", border: "none" }}
                onClick={() => {
                  setRefetch(true);
                  setDrModal(false);
                }}
              >
                OK
              </CButton>
            </CModalFooter>
          </CModal>
        </CCardHeader>
        <div style={{ margin: "16px" }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 20, 25]}
            disableRowSelectionOnClick
            autoHeight
            sx={{
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
            }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Visitations;
